import { Box, Typography } from '@montugroup/design-system';

type PharmacyLocationMarkerProps = {
  title: string;
  expanded: boolean;
};

export function PharmacyLocationMarker({ title, expanded }: PharmacyLocationMarkerProps) {
  return (
    <Box
      sx={{
        position: 'relative',
        pointerEvents: 'auto',
      }}
    >
      {!expanded && (
        <Box
          sx={(theme) => ({
            width: 16,
            height: 16,
            borderRadius: '50%',
            backgroundColor: theme.palette.secondary.main,
            border: '2px solid white',
            boxShadow: '0 0 2px rgba(0,0,0,0.25)',
          })}
        />
      )}

      {expanded && (
        <>
          <svg width="32" height="45" viewBox="0 0 32 45" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
              d="M15.75 0C7.0425 0 0 7.0425 0 15.75C0 27.5625 15.75 45 15.75 45C15.75 45 31.5 27.5625 31.5 15.75C31.5 7.0425 24.4575 0 15.75 0Z"
              fill="#FF9845"
            />
            <rect x="4" y="3" width="24" height="24" rx="12" fill="white" />
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M23.0204 14.4463V11.2162L21.7143 11.6825V13.0285C21.7143 13.1584 21.6627 13.283 21.5708 13.3748C21.479 13.4667 21.3544 13.5183 21.2245 13.5183C21.0946 13.5183 20.97 13.4667 20.8782 13.3748C20.7863 13.283 20.7347 13.1584 20.7347 13.0285V12.0325L19.2653 12.5576V16.5334L22.385 15.3632C22.5716 15.2931 22.7324 15.1678 22.846 15.004C22.9595 14.8402 23.0204 14.6456 23.0204 14.4463ZM21.5484 10.7016L22.5933 10.3287C22.5564 10.3041 22.5182 10.2815 22.479 10.2608L20.4075 9.22569C20.287 9.16546 20.1554 9.13072 20.0209 9.12364C19.8864 9.11657 19.7519 9.1373 19.6258 9.18455L19.0113 9.41508L21.4433 10.6311C21.4824 10.6507 21.5179 10.6742 21.5484 10.7016ZM17.7593 9.88398L20.2919 11.1509L18.8075 11.6805L16.3226 10.4378C16.3696 10.4103 16.4197 10.3866 16.4728 10.3666L17.7593 9.88398ZM18.2857 12.5152L15.8367 11.2907V14.5932C15.8367 14.7752 15.8875 14.9536 15.9832 15.1084C16.0789 15.2632 16.2159 15.3883 16.3788 15.4696L18.2857 16.4231V12.5152ZM14.8571 11.2841C14.8571 10.9994 14.9185 10.7251 15.0309 10.477C15.0505 10.3856 15.0958 10.3018 15.1615 10.2353C15.3848 9.88267 15.7198 9.60316 16.128 9.44969L19.2829 8.26765C19.5351 8.17305 19.8042 8.13147 20.0732 8.14552C20.3422 8.15956 20.6054 8.22893 20.8464 8.34928L22.9179 9.38504C23.2431 9.54786 23.5166 9.79801 23.7077 10.1075C23.8988 10.4169 24 10.7735 24 11.1372V14.4463C24 14.8451 23.8782 15.2345 23.651 15.5623C23.4238 15.8901 23.102 16.1407 22.7285 16.2807L19.5755 17.4628C19.3232 17.5575 19.0541 17.5991 18.785 17.585C18.5158 17.571 18.2525 17.5016 18.0114 17.3811L15.9399 16.3454C15.6146 16.1826 15.3409 15.9325 15.1497 15.6231C14.9585 15.3136 14.8572 14.957 14.8571 14.5932V11.2841Z"
              fill="#FF9845"
            />
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M13.6452 14.6942C13.1095 14.1584 12.3828 13.8573 11.6252 13.8571H8.98988C8.92057 13.3725 8.50379 13 8 13H7C6.44772 13 6 13.4477 6 14V19.5C6 20.0523 6.44772 20.5 7 20.5H8C8.54248 20.5 8.98449 20.0387 9 19.5L10.999 21.1957C11.5124 21.6232 12.1594 21.8572 12.8275 21.8571H20.1909C21.0322 21.8571 21.7143 21.175 21.7143 20.3337C21.7143 18.9669 20.6061 17.8571 19.2377 17.8571H15.4039C15.4661 17.6733 15.4979 17.4803 15.4979 17.2857C15.4979 17.0515 15.4518 16.8195 15.3621 16.6032C15.2725 16.3868 15.1411 16.1901 14.9755 16.0245L13.6452 14.6942ZM11.7302 20.3174C12.0383 20.5739 12.4265 20.7143 12.8274 20.7143H20.1909C20.401 20.7143 20.5714 20.5438 20.5714 20.3337C20.5714 19.5976 19.9745 19 19.2377 19H14.2067C14.047 19.0459 13.8812 19.0693 13.7143 19.0693C13.4801 19.0693 13.2481 19.0232 13.0317 18.9336C12.8153 18.8439 12.6187 18.7125 12.4531 18.5469L11.596 17.6898C11.3728 17.4666 11.3728 17.1048 11.596 16.8816C11.8191 16.6585 12.1809 16.6585 12.4041 16.8816L13.2612 17.7388C13.3207 17.7983 13.3914 17.8455 13.4691 17.8777C13.5468 17.9099 13.6302 17.9265 13.7143 17.9265C13.7984 17.9265 13.8818 17.9099 13.9595 17.8777C14.0372 17.8455 14.1079 17.7983 14.1674 17.7388C14.2269 17.6793 14.2741 17.6087 14.3063 17.5309C14.3385 17.4532 14.3551 17.3699 14.3551 17.2857C14.3551 17.2016 14.3385 17.1182 14.3063 17.0405C14.2741 16.9628 14.2269 16.8921 14.1674 16.8326L12.8371 15.5023C12.5157 15.1809 12.0797 15.0001 11.6252 15H9V18.0419L11.7302 20.3174Z"
              fill="#FF9845"
            />
          </svg>

          <Typography
            variant="body2"
            sx={{
              position: 'absolute',
              left: '100%',
              bottom: 18,
              ml: 1,
              whiteSpace: 'nowrap',
              fontWeight: 700,
              padding: 1,
              borderRadius: 1,
              backgroundColor: 'rgba(255, 255, 255, 0.6)',
            }}
          >
            {title}
          </Typography>
        </>
      )}
    </Box>
  );
}

export default PharmacyLocationMarker;
